import i18n, { DefaultNamespace, Namespace, ParseKeys } from "i18next"
import resourcesToBackend from "i18next-resources-to-backend"
import { initReactI18next, useTranslation } from "react-i18next"

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`./locales/${language}/${namespace}.json`),
    ),
  )
  .init({
    resources: {},
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    ns: [],

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    partialBundledLanguages: true,
    debug: import.meta.env.MODE === "development",
  })

export const VALIDATION_ERROR_KEYS = {
  AT_LEAST_ONE_OPTION_MUST_BE_SELECTED:
    "common:errors.at_least_one_option_must_be_selected",
  REQUIRED: "common:errors.required",
  MUST_BE_GREATER_THAN_OR_EQUAL_TO:
    "common:errors.must_be_greater_than_or_equal_to",
  MUST_BE_VALID_YEAR: "common:errors.must_be_valid_year",
  MUST_BE_VALID_URL: "common:errors.must_be_valid_url",
  MUST_BE_VALID_EMAIL: "common:errors.must_be_valid_email",
  MUST_BE_VALID_PHONE: "common:errors.must_be_valid_phone",
} as const

export function useTOptions<TNamespace extends Namespace = DefaultNamespace>(
  key: ParseKeys<TNamespace, { returnObjects: true }>,
  namespace?: TNamespace,
): SelectOption<string>[] {
  const valueLabelMap = useTObject(key, namespace)
  return Object.entries(valueLabelMap).map(([value, label]) => ({
    value,
    label,
  }))
}

export function useTObject<TNamespace extends Namespace = DefaultNamespace>(
  key: ParseKeys<TNamespace, { returnObjects: true }>,
  namespace?: TNamespace,
): Record<string, string> {
  const { t } = useTranslation(namespace)
  const tFunc = t as (
    key: ParseKeys<TNamespace, { returnObjects: true }>,
    options: { returnObjects: true },
  ) => Record<string, string>
  return tFunc(key, { returnObjects: true } as const)
}

export default i18n
